import moment from 'moment';
import classNames from 'classnames/bind';
import { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import Footer from '../components/Footer';
import Header from '../components/Header';
import Loading from '~/components/Loading';
import Sliders from '~/components/Sliders';
import styles from './DefaultLayout.module.scss';
import { dispatchPostError } from '~/redux/reducer/error';
import { requestPlayerGetSettings } from '~/services/auth';
import { dispatchSettings } from '~/redux/reducer/setting';
import { logoutAccountSuccess } from '~/redux/reducer/auth';

const cx = classNames.bind(styles);

function DefaultLayout({ children }) {
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const { error } = useSelector((state) => state.error);
    const { currentUser } = useSelector((state) => state.auth);
    const { website_status } = useSelector((state) => state.setting);

    useEffect(() => {
        const currentDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        const date = localStorage.getItem('_re');
        const currentDateMoment = moment(currentDate);
        const dateMoment = moment(date);

        // Nếu dateMoment quá 1 ngày thì reload lại
        if (currentDateMoment.diff(dateMoment, 'days') >= 1) {
            localStorage.removeItem('_re');
            navigate('/');
            window.location.reload();
        } else {
            const fetch = async () => {
                const result = await requestPlayerGetSettings('VN', 'vi');

                setLoading(false);
                if (result.status === 403) {
                    dispatch(logoutAccountSuccess());
                    localStorage.removeItem('_re');
                    navigate('/');
                    window.location.reload();
                } else if (result.status === 401) {
                    dispatch(dispatchPostError(result));
                } else if (result?.status === 200) {
                    dispatch(dispatchSettings(result.data));
                }
            };
            fetch();
        }

        console.log('%cCopyright © : https://thegioicode.com', 'color:green;font-size:14px;font-weight:bold');

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const validPaths = ['/garena-login', '/faq', '/terms', '/privacy'];

    const isValidPath = validPaths.some((path) => pathname.startsWith(path));

    return (
        <Fragment>
            {loading ? (
                <Loading height="100" />
            ) : website_status ? (
                <div className={cx('wrapper')}>
                    <Header />

                    <div className={cx(!isValidPath && 'container')}>
                        {!isValidPath && (
                            <Fragment>
                                {!pathname.startsWith('/freefire-login') && <Sliders />}

                                {/^\/(app|billing)(\/[^/]+)?$/.test(pathname) && (
                                    <div className={cx('border')}>
                                        {!pathname.startsWith('/freefire-login') && (
                                            <div className={currentUser ? cx('line') : cx('line', 'active')}></div>
                                        )}

                                        {currentUser ? (
                                            <Fragment>
                                                <div className={cx('logo')}>
                                                    <img src={currentUser?.app?.avatar_url} alt={currentUser?.app?.avatar_url} />
                                                </div>

                                                <h1 className={cx('game')}>Chọn phương thức thanh toán</h1>

                                                <div
                                                    className={cx('reload')}
                                                    onClick={() => {
                                                        window.location.reload();
                                                        localStorage.removeItem('_re');
                                                        localStorage.removeItem('timeout');
                                                    }}
                                                >
                                                    <span className={cx('icon-reload')}></span>
                                                    <span className={cx('text-reload')}>Làm mới</span>
                                                </div>
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                {!pathname.startsWith('/freefire-login') && (
                                                    <div className={cx('login')}>Chọn game để nạp</div>
                                                )}
                                            </Fragment>
                                        )}

                                        {!pathname.startsWith('/freefire-login') && (
                                            <div className={currentUser ? cx('line') : cx('line', 'active')}></div>
                                        )}
                                    </div>
                                )}
                            </Fragment>
                        )}

                        {children}
                    </div>
                    <Footer />
                </div>
            ) : (
                <div className={cx('website')}>
                    <div className={cx('text', 'code')}>{error.code || '502'}</div>
                    <div className={cx('text', 'message')}>{error.message || 'Bad Gateway'}</div>
                </div>
            )}
        </Fragment>
    );
}

export default DefaultLayout;
